import "core-js/modules/es.array.concat.js";
import { rootFontSize, pxToEm, pxToRem } from 'utils/ui/units';
import { alpha, getBorderColor } from 'utils/ui/colors';
export var COLLAPSED_NAVBAR_HEIGHT = 70;
var fontSize = rootFontSize;
var lineHeight = 1.5;
var maxPageWidth = 1200;
var typeScale = {
  xxxs: pxToRem(rootFontSize * 0.75),
  xxs: pxToRem(rootFontSize * 0.8125),
  xs: pxToRem(rootFontSize * 0.875),
  s: pxToRem(rootFontSize * 0.9375),
  m: pxToRem(rootFontSize),
  l: pxToRem(rootFontSize * 1.125),
  xl: pxToRem(rootFontSize * 1.375),
  xxl: pxToRem(rootFontSize * 1.625)
};
var spacing = {
  xxxs: pxToRem(2),
  xxs: pxToRem(4),
  xs: pxToRem(8),
  s: pxToRem(14),
  m: pxToRem(20),
  l: pxToRem(26),
  xl: pxToRem(32),
  xxl: pxToRem(42)
};
var breakpoints = {
  base: 0,
  xxxs: pxToEm(360, 16),
  xxs: pxToEm(600, 16),
  xs: pxToEm(760, 16),
  s: pxToEm(900, 16),
  m: pxToEm(1060, 16),
  l: pxToEm(1200, 16),
  xl: pxToEm(1400, 16),
  xxl: pxToEm(1800, 16),
  xxxl: pxToEm(2300, 16)
};
var z = {
  below: -1,
  flat: 0,
  raised: 10,
  dropdowns: 30,
  navbars: 40,
  modals: 50,
  alerts: 60,
  tooltips: 80
};
var borderStyles = {
  thin: function thin(theme) {
    return "1px solid ".concat(getBorderColor(theme));
  },
  dashed: function dashed(theme) {
    return "".concat(pxToRem(3), " dashed ").concat(getBorderColor(theme));
  }
};
var shadowStyles = {
  soft: function soft(theme) {
    return "0 0 0 1px ".concat(alpha(theme.shade, theme.lineStrength / 1.5), ",\n\t\t 0 ").concat(pxToRem(2), " ").concat(pxToRem(3), " ").concat(alpha(theme.shade, theme.lineStrength / 2));
  },
  softHover: function softHover(theme) {
    return "0 0 ".concat(pxToRem(6), " rgba(0, 0, 0, 0.2),\n\t\t 0 ").concat(pxToRem(3), " ").concat(pxToRem(8), " ").concat(getBorderColor(theme));
  },
  raised: function raised(theme) {
    return "".concat(shadowStyles.soft(theme), ",\n\t\t 0 ").concat(pxToRem(6), " ").concat(pxToRem(10), " ").concat(getBorderColor(theme));
  },
  topFold: function topFold(theme) {
    return "0 ".concat(pxToRem(6), " ").concat(pxToRem(11), " ").concat(pxToRem(-10), " ").concat(theme.shade);
  },
  bottomFold: function bottomFold(theme) {
    return "0 ".concat(pxToRem(-6), " ").concat(pxToRem(11), " ").concat(pxToRem(-10), " ").concat(theme.shade);
  }
};
var modalWidths = {
  narrow: 396,
  default: 460,
  wide: 540,
  extraWide: 720,
  fullPage: maxPageWidth
};
export { borderStyles, breakpoints, fontSize, lineHeight, maxPageWidth, modalWidths, shadowStyles, spacing, typeScale, z };